import React, { useState } from "react";
import { useMemberEditing, useMemberPage } from "./hook";
import { MainTemplate } from "../../templates/MainTemplate";
import { TableTemplate } from "../../templates/TableTemplate";
import { CreateMemberModal } from "../../organisms/modal/CreateMemberModal";
import { MemberFormData } from "../../organisms/form/MemberForm";
import { Member } from "../../../ducks/member";
import { EditMemberModal } from "../../organisms/modal/EditMemberModel";
import { USER_ROLE } from "../../../constants/app";
import { Resource, Permission } from "../../../constants/permissions";
import styled from "styled-components";
import { useResponsive } from "../../../hooks/useResponsive";

export const MemberPage = () => {
  const { isMobile } = useResponsive();
  const {
    tableHeaders,
    members,
    loading,
    fetchData,
    handleRowDelete,
    handleCloseCreateModal,
    handleCloseEditModal,
    handleOpenCreateModal,
    handleOpenEditModal,
    isCreateModalOpen,
    isEditModalOpen,
    refetchMembers,
  } = useMemberPage();
  // const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const [selectedMember, setSelectedMember] = useState<Member | null>(null);


  return (
    <>
      <MainTemplate
        title="Members"
        useFitHeight
        button={{
          text: "Create",
          variant: "filled",
          onClick: handleOpenCreateModal,
          permission: {
            resource: Resource.MEMBERS,
            permission: Permission.CREATE,
          },
        }}
      >
        <StyledTableWrapper $isMobile={isMobile}>
          <TableTemplate<Member & { name: string; email: string; userRole: USER_ROLE; no: number }>
            headers={tableHeaders}
            data={members}
            fetchDataFunction={fetchData}
            columnWidths={["8%", "25%", "25%", "15%", "25%"]}
            editable
            deletable
            showHeaderDeleteIcon={false}
            resource={Resource.MEMBERS}
            onPermissionError={(message) => {
              // You can use the existing toast system here
              console.error(message);
            }}
            onEdit={(member) => {
              setSelectedMember(member);
              handleOpenEditModal();
            }}
            onDelete={handleRowDelete as any}
            stickyHeader
            hasPagination={false}
          />
        </StyledTableWrapper>
      </MainTemplate>

      <CreateMemberModal
        isOpen={isCreateModalOpen}
        onClose={handleCloseCreateModal}
        refetchMembers={refetchMembers}
      />

      {selectedMember && (
        <EditMemberModal
          isOpen={isEditModalOpen}
          onClose={handleCloseEditModal}
          defaultValues={{
            name: selectedMember.username,
            email: selectedMember.email,
            userRole: selectedMember.role as unknown as USER_ROLE
          }}
          memberId={selectedMember.id}
          refetchMembers={refetchMembers}
        />
      )}
    </>
  );
};

const StyledTableWrapper = styled.div<{ $isMobile?: boolean }>`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: auto;
  
  ${({ $isMobile }) =>
    $isMobile
      ? `
      -webkit-overflow-scrolling: touch;
      max-height: calc(100vh - 200px);
      `
      : `
      max-height: calc(100vh - 250px);
      `}
`;
